module.exports = __webpack_public_path__ + "static/media/ic_choose_by_url.b984d861.svg";